import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PromotionalBanner from "./sections/PromotionalBanner";
import UnbeatableDealsOnTopBrands from "./sections/UnbeatableDealsOnTopBrands";
import VisitUsTodaySection from "./sections/VisitUsTodaySection";
import YourDreamApplianceAwaits from "./sections/YourDreamApplianceAwaits";
import ExploreOurRange from "./sections/ExploreOurRange";
import WhyChooseSmartBuyAppliances from "./sections/WhyChooseSmartBuyAppliances";
import FeaturedAppliances from "./sections/FeaturedAppliances";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <UnbeatableDealsOnTopBrands />
      <VisitUsTodaySection />
      <YourDreamApplianceAwaits />
      <ExploreOurRange />
      <WhyChooseSmartBuyAppliances />
      <FeaturedAppliances />
      <PromotionalBanner />
      <Footer />
    </div>;
}